import { Fax } from '@/models/Fax';
import { getField, updateField } from 'vuex-map-fields';
import { httpError } from '@/models/httpError';
import { HTTP } from '@/http-common';

const state = {
  rows: [],
  message: new httpError(),
};

//getters

const getters = {
  getField,
};

//Mutations
const mutations = {
  setFax(state, faxes) {
    state.rows = faxes;
  },
  addRow(state) {
    if (state.rows.length > 0) state.rows.push(new Fax());
    else {
      state.rows = [new Fax()];
    }
  },
  addEmail(state, payload) {
    state.rows[payload.index].outgoingEmail.push({
      email: payload.email,
    });
  },
  deleteRow(state) {
    // To enable multi-row form handling
    // we make it possible to add new rows.
    state.rows.pop();
  },
  setProgress(state, message) {
    state.message = message;
  },
  removeRow(state, index) {
    state.rows.splice(index, 1);
  },
  removeEmail(state, payload) {
    state.rows[payload.index].outgoingEmail.splice(
      state.rows[payload.index].outgoingEmail.indexOf(payload.email),
      1
    );
  },
  updateField,
};

//ACTIONS
const actions = {
  reset({ commit }) {
    commit('setFax', [new Fax()]);
  },
  addEmail({ commit }, payload) {
    commit('addEmail', payload);
  },
  async getFax({ commit, dispatch, rootState }) {
    try {
      var order = await HTTP.get(
        'order/GetFax/' + rootState.orders.rows[0].orderID
      );
      if (order.data == null || order.data.length == 0) {
        order.data = [new Fax()];
      }
      commit('setFax', order.data);
      dispatch(
        'setMessage',
        new httpError({
          message: 'Retreived OK',
          httpStatus: 200,
        })
      );
      return Promise.resolve(order);
    } catch (err) {
      dispatch(
        'setMessage',
        new httpError({
          message: 'Error getting order:' + err,
          httpStatus: 500,
        })
      );
      return Promise.reject(err);
    }
  },
  async saveFax({ commit, dispatch, rootState, state }) {
    try {
      var order = await HTTP.post(
        'order/AddFax/' + rootState.orders.rows[0].orderID,
        state.rows
      );
      commit('setFax', order.data);
      dispatch(
        'setMessage',
        new httpError({
          message: 'saved OK',
          httpStatus: 200,
        })
      );
      return Promise.resolve(order.data);
    } catch (err) {
      dispatch(
        'setMessage',
        new httpError({
          message: 'unable to save:' + err,
          httpStatus: 500,
        })
      );
      return Promise.reject(err);
    }
  },
  async removeRows({ state, commit, rootState }, newVal) {
    var oldVal = 0 || state.rows.length;
    var rows = [];
    for (var i = oldVal; i > newVal; i--) {
      rows.push(state.rows[i - 1].faxID);
      commit('deleteRow');
    }
    try {
      var faxes = await HTTP.delete(
        'order/DeleteFaxFromOrder/' + rootState.orders.rows[0].orderID,
        {
          data: rows,
        }
      );
      return Promise.resolve(faxes);
    } catch (e) {
      return Promise.reject(e);
    }
  },
  removeRow({ state, rootState, commit, dispatch }, index) {
    return new Promise((resolve, reject) => {
      HTTP.delete(
        'order/DeleteFaxFromOrder/' + rootState.orders.rows[0].orderID,
        {
          data: [state.rows[index].faxID],
        }
      )
        .then(() => {
          commit('removeRow', index);
          resolve();
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'unable to save:' + err.message,
              httpStatus: 500,
            })
          );
          reject(err.message);
        });
    });
  },

  setMessage({ commit }, message) {
    commit('setProgress', message);
    if (message.httpStatus !== 500)
      setTimeout(() => {
        commit('setProgress', new httpError());
      }, 2000);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
